
import { APP_URLS } from "../../const/AppConst";
import { staticBaseUrl } from "../../config/GlobalConfig";
import useAppState from "../../context/AppContext";
import MenuItem from "../../components/common/MenuItem";
import { useLocation } from "react-router-dom";
import { isDoneProposition } from '../../utils/dataUtils';


export default function SidePannelBloc() {
  const {
    state: {proposition, infoSteps, reviewMode, isConseiller },
  } = useAppState();

  const currentLocation = useLocation();

  const isDone = proposition && isDoneProposition(proposition!);

  let filteredSteps;

  if (!proposition?.configuration?.canBeAddedBeneficiaries && !proposition?.configuration?.hasOfferStep) {
    filteredSteps = infoSteps.filter(step => step.category === 'PERSONAL' && step.code !== 'PERSO_RECAP');
  } else if (!proposition?.configuration?.hasSalaryStep) {
    filteredSteps = infoSteps.filter(step => step.category === 'PERSONAL' && step.code !== 'PERSO_COTISATION');
  } else {
    filteredSteps = infoSteps.filter(step => step.category === 'PERSONAL');
  }

  return (
    <aside className="adherent-lateralnav lateral-nav bg-blanc shadow-bleu">
      <img src={staticBaseUrl + "/img/mgp.svg"} alt="MGP" className="m-x-xl m-y-lg ta-center sc-appear-fromtop logo isreveal"/>
      {
        isConseiller && isDone && currentLocation.pathname !== APP_URLS.postSignatureActionPage && 
        <div>
          <MenuItem label='Récapitulatif' name="" path={APP_URLS.recapPage} state="conseiller-active"/>
          {proposition?.configuration?.hasSignature && <MenuItem label='Documents signés' name="" path={APP_URLS.infoSignatureStep2Page} state="conseiller-active"/>}
          <MenuItem label='Justificatifs' name="" path={APP_URLS.listInvalidDocumentPage} state="conseiller-active"/>  
          <MenuItem label='Correctif des informations' name="" path={APP_URLS.infoModificationPage} state="conseiller-active"/>
        </div>
      }
      {
        (!isConseiller || !isDone) &&
        <div className="hide-in-mobile">
        
          {proposition?.configuration?.hasShowPriceAmount === true &&
            <MenuItem label='Votre couverture mutuelle' name="DEMANDE" path={APP_URLS.infoPersoStep0Page}
            />
          }
            <MenuItem label="Je m'affilie" name="PERSONAL" path={APP_URLS.infoPersoStep1Page}
              subMenuItems={filteredSteps}
            />
          {proposition?.configuration?.canBeAddedBeneficiaries && 
            <MenuItem label="Je couvre mes proches"name="BENEFICIARY" path={APP_URLS.infoBeneficiaryStep0Page}
              subMenuItems={infoSteps.filter(step => step.category === 'BENEFICIARY')}
            />
          }
          
          {proposition?.configuration.hasOfferStep &&
            <MenuItem label='Je renforce ma couverture' name="GUARANTY" path={APP_URLS.guarantyPage} subMenuItems={infoSteps.filter(step => step.category === 'GUARANTY')}
            />
          }
            
            
          {
            reviewMode ?
            <MenuItem  label='Je finalise' name="SIGNATURE" path={APP_URLS.recapPage}
              subMenuItems={infoSteps.filter(step => step.category === 'SIGNATURE')}
            /> :  
            <MenuItem  label='Je finalise' name="SIGNATURE" path={APP_URLS.recapPage}
              subMenuItems={infoSteps.filter(step => step.category === 'SIGNATURE' && !step.reviewMode)}
            />
          }    
        </div>
      }
     
    </aside>
  )
}
